import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import {
  IAwardWithStarsAndImageProps,
  IImageWithDescription
} from '../components/award-with-stars-and-image/award-with-stars-and-image';

export class AwardWithStarsAndImageModel extends ContentItem {
  get starText(): string {
    return get(this._config, 'elements.stars_text.value', {});
  }

  get starsImage(): IImageWithDescription {
    return get(this._config, 'elements.stars_image.value[0]', {});
  }

  get awardImage1(): IImageWithDescription {
    return get(this._config, 'elements.award_image_1.value[0]', {});
  }

  get awardImage2(): IImageWithDescription {
    return get(this._config, 'elements.award_image_2.value[0]', {});
  }

  get awardImage3(): IImageWithDescription {
    return get(this._config, 'elements.award_image_3.value[0]', {});
  }

  public static create(
    data: IAwardWithStarsAndImage
  ): IAwardWithStarsAndImageProps {
    const {
      starText,
      starsImage,
      awardImage1,
      awardImage2,
      awardImage3
    } = new AwardWithStarsAndImageModel(data);
    return {
      starText,
      starsImage,
      awardImage1,
      awardImage2,
      awardImage3
    };
  }
}
